import React, { useState, useEffect } from 'react';
import Select from 'react-select-nested-group';
import * as R from 'ramda';
import moment from 'moment';
import toastr from "toastr";
import transform from './observationHelper';
import { Spinner } from '../common/Spinner';
import DateTime from 'react-datetime';

import Things from "../../ducks/Things";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PaginatedTable from '../common/PaginatedTable';


const ObservationPage = (props) => {

  const [selectedVehicle, setSelectedVehicle] = useState('');
  const [things, setThings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableValues, setTableValues] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [selectedHours, setSelectedHours] = useState({ value: 12, label: 12 })

  const data = JSON.parse(localStorage.getItem("companyInfo"));
  const companyId = data.companyId;
  let columns = [
    { name: 'Imei' , selector: "imei", wrap: true},
    { name: 'Temperature' , selector: "temperature"},
    { name: 'Humidity' , selector: "humidity", wrap: true},
    { name: 'Timestamp' , selector: "timestamp", wrap: true},
    { name: 'LatLng' , selector: "latlng", wrap: true},
    { name: 'GSM_Signal' , selector: "GSM_Signal", wrap: true},
    { name: 'GNSS_Status' , selector: "GNSS_Status", wrap: true},
    { name: 'External_Voltage' , selector: "External_Voltage", wrap: true},
    { name: 'Battery_Voltage' , selector: "Battery_Voltage", wrap: true},
    { name: 'Ignition' , selector: "Ignition", wrap: true},
    { name: 'Unplug' , selector: "Unplug", wrap: true},
    { name: 'Location' , selector: "location", wrap: true},
  ];
  let headers = [
    { label: 'Imei' , key: "imei", wrap: true},
    { label: 'Temperature' , key: "temperature"},
    { label: 'Humidity' , key: "humidity"},
    { label: 'Timestamp' , key: "timestamp", wrap: true},
    { label: 'GSM Signal' , key: "GSM_Signal"},
    { label: 'GNSS Status' , key: "GNSS_Status"},
    { label: 'External Voltage' , key: "External_Voltage"},
    { label: 'Battery Voltage' , key: "Battery_Voltage"},
    { label: 'Ignition' , key: "Ignition"},
    { label: 'Unplug' , key: "Unplug"},
    { label: 'Location' , key: "location"},
  ];


  const hoursArray = R.unfold(h => h <= 24 ? [h, h + 1] : false, 1)
  

  const actions = {
    async onSubmit(event) {
      event.preventDefault();
      if (!selectedVehicle) {
        return toastr.error('Id is required.')
      }
      if (!selectedDate) {
        return toastr.error('Start date is required.')
      }
      if (!selectedHours) {
        return toastr.error('Hours selection is required.')
      }
      const endDate = moment(selectedDate).add(selectedHours.value, 'hours');
   
      const interval = {
        startDate: moment(selectedDate),
        endDate: moment(endDate),
      }
      setIsLoading(true);
      const observations = await props.actions.getObservations(selectedVehicle.value, JSON.stringify({ interval }));
      setIsLoading(false);
      const filter = row => {
        return row};
      const values = R.compose(R.filter(filter), (s) => {
        return s;
      }, 
      R.map(transform(selectedVehicle.label)))(observations);
      setTableValues(values);
    },



    handleVehicleChange(option) {
      setSelectedVehicle(option);
    },
  }

  const loadThings = async () => {
    setIsLoading(true);
    let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
    await props.actions.getGroupVehicles({ groupId:  companyInfo.groupId });
    // const mappedValues = R.map(thing => ({ value: thing.name, label: `${thing.plateNumber || 'N/A'}` }))(things);
    // setThings(mappedValues);
    setIsLoading(false);
  }

  useEffect(() => {
    loadThings();
  }, []);

  useEffect(() => {
    const mappedValues = R.map(thing => ({ value: thing.imei, label: `${thing.name || 'N/A'}` }))(props.things);
    setThings(mappedValues);
  },[props.things]);
  return !isLoading ? (

    <div>


      <div className="row" style={{ margin: '0px 0px 25px 0' }}>

        <div className="col-lg-3 col-sm-3">
          <label>Select Things</label>
          <Select
            name="form-field-selectedThing"
            value={selectedVehicle}
            searchable={true}
            onChange={actions.handleVehicleChange}
            options={things} />

        </div>
        <div className="col-lg-3 col-sm-3" >
          <label>Date</label>
          <DateTime value={selectedDate} dateFormat="DD-MM-YYYY" timeFormat="HH:mm" onChange={setSelectedDate} />

        </div>
        <div className="col-lg-3 col-sm-3" >
          <label >Duration (Hours)</label>
          <Select
            name="form-field-name"
            isClearable={false}
            isSearchable={true}
            placeholder="Select"
            defaultValue={selectedHours}
            onChange={setSelectedHours}
            options={hoursArray.map(h => {
              return { value: h, label: h }
            })} />
        </div>
        <div className="col-lg-3" style={{ padding: '25px 0 0 25px' }}>
          <button className={`btn btn-primary search-btn  search-button`} onClick={actions.onSubmit}>Search</button>
        </div>
      </div>
      <PaginatedTable columns={columns} headers={headers} data={tableValues} title="Observation List" fileName="Observation List" />
    </div>) : <div style={{
      'marginTop': '20%'
    }}><Spinner/></div>;
}

const mapStateToProps = state => ({ things: state.things.groupVehicles, });
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Things.creators, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(ObservationPage);
